import { Grid } from "@mui/material";

const Contact = () => {
  return <>
    <Grid container justifyContent='center'>
      <Grid item sm={10}>
        <h1>Contact Page</h1>
        <hr />
        <p>Rahul Kumar</p>
        <p>Email: rahul@example.com</p>
        <p>Phone: 9103596788</p>
      </Grid>
    </Grid>
  </>;
};

export default Contact;
